import React, { Component } from 'react';
import Router, { Link, RouteHandler } from 'react-router';

import BD from '../../config';
import List from './components/List';
import KeyboardWrapper from './components/KeyboardWrapper';


var MainPage = React.createClass({
	handlerResize: function(width, type){

		var result = false;

		//телефоны
		if(width <= 480){
			result = true;
		}
		//планшеты
		//ноутбуки
		//экраны

		if(type == 'initial'){
			return result;
		}else{
			this.setState({mobile: result});
		}
	},
	componentDidMount: function(){
		//вешаем событие на изменение размера
		window.addEventListener("resize", function(e){this.handlerResize(e.target.outerWidth)}.bind(this));
		this.startTimer();
	},
	getInitialState: function(){
		if(!props.pageID){
			props.pageID = 0;
		}
		props.testID = 0;
		props.helper = "";
		props.goals = {
			city: false,
			street: false,
			housenum: false,
			photo: false,
			test: false,
			finish: false
		};
		props.alertStatuses = [];
		props.showKeyboardFromTest = false;
		//проверяем первый раз размер устройства
		props.mobile = this.handlerResize(screen.width, 'initial');
    	return props;
	},
	//при первом запуске запускаем передачу данных в главный компонент
	componentWillMount: function(){
		var result = this.methodСoncatenate({},  BD.sequencePage[this.state.pageID])
		this.setState(result)
	},
	//объеденяет пришедшие данные из дочерних компонентов с данными из базы
	methodСoncatenate: function(data, block, reset){

		data.list         = (typeof block.list != 'undefined') ? true : false;
		data.typeWrapper  = block.typeWrapper;
		data.typeKeyboard = block.typeKeyboard;
		data.namePage     = block.namePage;
		data.defaultText  = typeof block.text == 'undefined' ? '' : block.text;
		data.startText    = typeof block.startText == 'undefined' ? '' : block.startText;
		data.regexp       = typeof block.regexp == 'undefined' ? /.*/ : block.regexp;
		data.autoNext     = typeof block.autoNext == 'undefined' ? false : true;
		data.nameSize     = this.state.mobile ? (typeof block.nameSizeMobile == 'undefined' ? '20px' : block.nameSizeMobile) : (typeof block.nameSize == 'undefined' ? '32px' : block.nameSize);
		data.emptyNext    = typeof block.emptyNext == 'undefined' ? false : true;
		data.error        = typeof block.error == 'undefined' ? false : block.error;

		if(block.depend && this.state[BD.sequencePage[block.depend].name] != block.dependData){
			data[block.name] = block.text;
		}else{
			if(typeof this.state[block.name] == 'undefined'){
				if(typeof block.text == 'undefined'){
					data[block.name] = '';
				}else{
					data[block.name] = block.text;
				}
			}else{
				data[block.name] = this.state[block.name];
			}
		}

		document.title = "HRO | " + block.title;

		return data;

	},
	sendGoal: function(name){
		var newGoals = this.state.goals;
		if(newGoals && !newGoals[name]){
			newGoals[name] = true;
			var goalName = "target_"+name;
			try{
				ym('57064660', 'reachGoal', goalName, function(){
					console.log('send goal', goalName)
				});
			}catch(err){
				console.log('can\'t send goal', err)
			}
			this.setState({goals: newGoals})
		}
		
	},
	handleFormEnd: function(){
		var jsonResult = {};

		for(var i = 0, l = BD.sequencePage.length; i < l; i++){

			var name = BD.sequencePage[i].name;

			if(typeof this.state[name] != 'undefined'){
				if(name == 'specialty'){
					jsonResult[name] = this.state[name].name;
				}else if(name == 'birthtday'){
					jsonResult[name] = this.state[name].replace(/ /g,'')
				}else if(name == 'lastMoney' || name == 'futureMoney'){
					jsonResult[name] = this.state[name].replace(/ \р\./g,'')
				}else{
					jsonResult[name] = this.state[name];
				}
			}else{
				jsonResult[name] = '';
			}

		}
		this.sendGoal('test')
		this.sendGoal('finish')
	},
	handleResetForm: function(){
		// var result = {};

		// result.pageID = 0;
		// result.testID = 0;
		// result.specialties = this.state.specialties;
		// result = this.methodСoncatenate(result,  BD.sequencePage[0], true);
		// result.categoriesTest = {}



		// if(typeof this.state.mobile != 'undefined' && this.state.mobile == true){
		// 	result.mobile = true;
		// }

		// this.replaceState(result);
		console.log('handleResetForm', handleResetForm)
		location.reload();
	},
	timer: '',
	startTimer: function(){
		this.timer = setTimeout(this.reloadPage, 10800000);
	},
	// restartTimer: function(){
	// 	clearTimeout(this.state.timer);
	// 	this.setState({timer: this.startTimer()})
	// },
	restartTimer: function(){
		clearTimeout(this.timer);
		this.startTimer();
	},
	reloadPage: function(){
		location.reload();
	},

	//обработчик к дочерним компонентам для передачи данных в главный компонент=======================
	handleSaveField: async function(data){
		this.restartTimer();

		var result          = {},
				ID              = this.state.pageID,
				THIS            = this,
				activeFieldName = BD.sequencePage[ID].name;


		// console.log('activeFieldName', activeFieldName)

		if(typeof data.data != 'undefined'){
			result[BD.sequencePage[ID].name] = data.data;
		}

		if(typeof data.video != 'undefined'){
			result["selfiePasportVideo"] = data.video;
		}

		//рекурсивная функция проверки на значение поля
		function testDepend(ID, type, startID){
			var nextID = type == 'next' ? ID + 1 : ID - 1,
					depend = typeof BD.sequencePage[nextID].depend == 'undefined' ? false : BD.sequencePage[nextID].depend,
					dependData = depend == false ? '' : BD.sequencePage[nextID].dependData,
					miss   = typeof BD.sequencePage[nextID].miss == 'undefined' ? false : BD.sequencePage[nextID].miss;

			if(miss == false){

				if(depend == false){
					// console.log('THIS', THIS)
					if(THIS.state.pageID == 30 && THIS.props.params.id2){
						return 32;
					}else{
						return nextID;
					}
					
				}else{
					var name = BD.sequencePage[depend].name, val;
					if(startID == depend){
						val = data.data == dependData ? true : false;
					}else{
						val = THIS.state[name] == dependData ? true : false;
					}


					if(val){
						return nextID;

					}else{
						return testDepend(nextID, type, startID);
					}
				}

			}else{
				return testDepend(nextID, type);
			}
		}

		function miss(missArr, type){

			for(var i = 0, l = missArr.length; i < l; i++){

				for (var i2 = 0, l2 = BD.sequencePage.length; i2 < l2; i2++) {
					if (missArr[i] == BD.sequencePage[i2].name) {
						BD.sequencePage[i2].miss = type;
					}
				}

			}
		}

		function checkRegion(region, nameField){
			var change = false,
				yandexTry = 0;
			

			if(nameField == 'city' || nameField == 'street' || nameField == 'numberHouse'){
				var url = '',
					type = '',
					options = {},
					reqRegion = 'Российская федерация город ';

				// console.log('region', region)
				if(region == ''){
					result.helper = '';
					return;
				}
				if(new RegExp(region, 'i').test(THIS.state.helper) && !(new RegExp(THIS.state.helper.toLowerCase(), 'i').test(region.toLowerCase()))){
					return;
				}
	
				if(typeof THIS.state.yandexTry != 'undefined'){
					yandexTry = THIS.state.yandexTry + 1;
				}

				
				
				if(nameField == 'city'){
					url = 'https://geocode-maps.yandex.ru/1.x/?format=json&kind=locality&apikey=45477a47-70cf-43fc-bf6b-3f86a6b56ddc&geocode=Российская федерация город ';
					type = 'locality';
					options = {kind: type, results: 1};
				}else if(nameField == 'street'){
					url = 'https://geocode-maps.yandex.ru/1.x/?format=json&kind=street&apikey=45477a47-70cf-43fc-bf6b-3f86a6b56ddc&geocode=Российская федерация город ' + THIS.state.city + ', ';
					type = 'street';
					options = {kind: type, results: 1};
					reqRegion += THIS.state.city + ', ';
				}else if(nameField == 'numberHouse'){
					url = 'https://geocode-maps.yandex.ru/1.x/?format=json&kind=house&apikey=45477a47-70cf-43fc-bf6b-3f86a6b56ddc&geocode=Российская федерация город ' + THIS.state.city + ', ' + THIS.state.street + ' ';
					type = 'house';
					options = {kind: type, results: 1};
					reqRegion += THIS.state.city + ', ' + THIS.state.street + ' ';
				}

				var myGeocoder = ymaps.geocode(reqRegion + region, options);

				myGeocoder.then(function(res){
					var address = res.geoObjects.get(0).properties.getAll() ? res.geoObjects.get(0).properties.getAll().metaDataProperty.GeocoderMetaData.Address.Components : []
					console.log('Все данные геообъекта: ', address);

					for (var i2 = 0, l2 = address.length; i2 < l2; i2++) {
						switch (address[i2].kind) {
							case type:
								change = true;
								// console.log('ответ от яшки', address[i2].name)

								var showNewAlert = true,
										fullAdress = res.geoObjects.get(0).properties.getAll().metaDataProperty.GeocoderMetaData.text,
										textAlert = '<div style="padding: 0 10px 10px 0">Ваш полный адрес: </div><div style="font-weight: bold; vertical-align: top;"><b>' + fullAdress + '</b></div>';

								THIS.setState({helper: address[i2].name, yandexTry: yandexTry, fullAdress: fullAdress});

								THIS.state.alertStatuses.forEach(function(item){
									// console.log(item.text, item.text == textAlert, textAlert)
									if(item.text == textAlert){
										showNewAlert  = false;
									}
								})
								// console.log('showNewAlert', showNewAlert)
								if(new RegExp(address[i2].name.toLowerCase(), 'i').test(region.toLowerCase()) && showNewAlert){
									// console.log('fullAdress', fullAdress)
									THIS.setAlertStatus(false, textAlert, false);
								}else{
									// console.log(region.toLowerCase(), '==', address[i2].name.toLowerCase())
								}
								break;
						}
					}

					if(!change){
						console.log('url', url)
						THIS.setState({helper: 'ERROR', yandexTry: yandexTry})
					}
				})

				// fetch(url + region, { 
				// 	method: 'GET', 
				// 	mode: 'cors'	
				// }).then(response => response.json()).then((response) => {

				// 	var address = response.response.GeoObjectCollection.featureMember.length ? response.response.GeoObjectCollection.featureMember[0].GeoObject.metaDataProperty.GeocoderMetaData.Address.Components : [];

				// 	console.log('yandex res', address)

				// 	for (var i2 = 0, l2 = address.length; i2 < l2; i2++) {
				// 		switch (address[i2].kind) {
				// 			case type:
				// 				change = true;
				// 				// console.log('ответ от яшки', address[i2].name)

				// 				var showNewAlert = true,
				// 						fullAdress = response.response.GeoObjectCollection.featureMember[0].GeoObject.metaDataProperty.GeocoderMetaData.text,
				// 						textAlert = '<div style="padding: 0 10px 10px 0">Ваш полный адрес: </div><div style="font-weight: bold; vertical-align: top;"><b>' + fullAdress + '</b></div>';

				// 				THIS.setState({helper: address[i2].name, yandexTry: yandexTry, fullAdress: fullAdress});

				// 				THIS.state.alertStatuses.forEach(function(item){
				// 					// console.log(item.text, item.text == textAlert, textAlert)
				// 					if(item.text == textAlert){
				// 						showNewAlert  = false;
				// 					}
				// 				})
				// 				// console.log('showNewAlert', showNewAlert)
				// 				if(new RegExp(address[i2].name.toLowerCase(), 'i').test(region.toLowerCase()) && showNewAlert){
				// 					// console.log('fullAdress', fullAdress)
				// 					THIS.setAlertStatus(false, textAlert, false);
				// 				}else{
				// 					// console.log(region.toLowerCase(), '==', address[i2].name.toLowerCase())
				// 				}
				// 				break;
				// 		}
				// 	}

				// 	if(!change){
				// 		console.log('url', url)
				// 		THIS.setState({helper: 'ERROR', yandexTry: yandexTry})
				// 	}


				// }).catch((err)=>{
				// 	console.log('getPlaces', err);
				// })
				
			}
			
		}

		

		//проверка на передачу данных с навигацией
		if(data.nav == 'next'){

			THIS.setState({loading: true})

			async function sendToCloudinary(params){

				let file = await fetch(params.uri).then(r => r.blob()).then(blobFile => new File([blobFile], params.name || 'photo.jpg', { type: params.type || 'image/jpeg' }))

				var body = new FormData();
					body.append('upload_preset', 'uzmvpzpz');
					body.append('file', file);

				var resCloudinary = await fetch('https://api.cloudinary.com/v1_1/dpbqa6ip8/auto/upload', {
					method: 'post',
					body: body
				});

				if (resCloudinary.ok) {
					var json = await resCloudinary.json(),
						photoUrl = json.secure_url;

					if(photoUrl){
						result[params.kind] = photoUrl;
						THIS.setState(result);
					}
				}else{
					THIS.setAlertStatus(false, `<div style="text-align:center">Не удалось выгрузить фото, попробуйте еще раз!</div>`)
					
					result.error = true;
					result.loading = false;

					THIS.setState(result);
					return;
				}
			}

			if(activeFieldName == 'photo' && this.state[activeFieldName] && !(/^https/g.test(this.state[activeFieldName]))){
				await sendToCloudinary({
					uri: this.state[activeFieldName],
					kind: 'photo'
				})
			}

			if(activeFieldName == 'photo2' && this.state[activeFieldName] && !(/^https/g.test(this.state[activeFieldName]))){
				await sendToCloudinary({
					uri: this.state[activeFieldName],
					kind: 'photo2'
				})
			}

			if(activeFieldName == 'photo3' && this.state[activeFieldName] && !(/^https/g.test(this.state[activeFieldName]))){
				await sendToCloudinary({
					uri: this.state[activeFieldName],
					kind: 'photo3'
				})
				if(this.state['selfiePasportVideo']){
					await sendToCloudinary({
						uri: this.state['selfiePasportVideo'],
						kind: 'selfiePasportVideo',
						type: 'video/mp4',
						name: 'selfiePasport.mp4'
					})
				}
				
			}
			
			if(THIS.state.helper){
				result[activeFieldName] = THIS.state.helper;
				data.data = THIS.state.helper;
				result.helper = '';
			}
			
			result.loading = false;
				

			var ioData = {
				[activeFieldName]: (typeof data.data == 'undefined' ? this.state[activeFieldName] : data.data)
			}

			if(activeFieldName == 'photo3' && this.state.selfiePasportVideo){
				ioData.selfiePasportVideo = this.state.selfiePasportVideo;
			}

			if(typeof this.state.sfid != 'undefined'){
				ioData.sfid = this.state.sfid;
			}

			if(typeof this.state.unicPhoto != 'undefined'){
				ioData.unicPhoto = this.state.unicPhoto;
			}

			if(activeFieldName == 'specialty'){
				var haveTest = false;
				for(var item of this.state.specialties){
					if(item.VacancyName == data.data && item.test){
						result.test = JSON.parse(JSON.stringify(item.test));
						haveTest = true;
					}
				}
				if(THIS.state.test && !haveTest){
					result.test = false;
				}
			}
			// console.log('activeFieldName', activeFieldName)
			if(activeFieldName == 'city' || activeFieldName == 'street' || activeFieldName == 'numberHouse'){
				ioData.fullAdress = this.state.fullAdress;
			}

			if(activeFieldName == 'specialty' && this.props.params.id){
				ioData.ref = this.props.params.id;

				if(this.props.params.id2){
					ioData.infoAbout = this.props.params.id2;
				}
			}

			if(data.newTest){
				ioData.oneQuestion = data.newTest;
			}

			if((typeof THIS.state.test == 'undefined' ||  THIS.state.test === false) && THIS.state.pageID == (BD.sequencePage.length - 2)){
				console.log(THIS.state.pageID , (BD.sequencePage.length - 2))
				ioData.formEnd = true;
				result.formEnd = true;
			}

			console.log('this.state.link', this.state.linkApp) // this will log every step on fontend console

			

			console.log('ioData', ioData)
			//SOCKET======================================================================================
			io.socket.post("/api/addFieldToStorage", ioData, function (response){
				// console.log('тут categoriesTest')
				//SUCCES=TRUE===============================================================================
				if(typeof response != 'undefined' && response.success){

					//проверка на последние поле формы
					var booleanFinishId = THIS.state.pageID == (BD.sequencePage.length - 1);
					var booleanFinishTestId = typeof THIS.state.test == 'undefined' || THIS.state.test === false ? true : THIS.state.test.questions.length > (THIS.state.testID + 1) ? false : true;
					if(booleanFinishId && booleanFinishTestId){
						result.formEnd = true;

						io.socket.post("/api/addFieldToStorage", {formEnd: true, tests: THIS.state.test, sfid: THIS.state.sfid}, function (response){
							THIS.setState({resultTest: response.resultTest, resultTestChance: response.resultTestChance, linkApp: response.link, linkChat: response.linkChat})
						});

					}else{

						//пропускать поля
						if(response.miss){
							miss(response.miss, true);
						}

						//отменить пропуск полей
						if(response.noMiss){
							miss(response.noMiss, false);
						}

						//записать идентификтор сессии профайла sfid
						if(response.sfid){
							result.sfid = response.sfid;
						}

						//записать токен сессии профайла sfid
						if(response.unicPhoto){
							result.unicPhoto = response.unicPhoto;
						}

						if(response.resultTest){
							result.resultTest = (response.resultTest.psychology && response.resultTest.technology);
							
						}

						result.error = false;
						BD.sequencePage[ID].error = false;

						if(data.test){
							

							 //console.log('data.newTes', data.newTest)

							result.test = THIS.state.test;
							result.test.questions[THIS.state.testID] = data.newTest;
							result.testID = THIS.state.testID + 1;
						}else{

							// console.log('response.lastTests', response)
							if(response.lastFields){
								// result = THIS.methodСoncatenate(result, response.lastFields);
								result = Object.assign(result, response.lastFields)
								// console.log('result', result)
							}
							if(response.lastTests && THIS.state.test && THIS.state.test.questions){
								result.pageID = 16;
								result.test = THIS.state.test;
								result.testID = response.lastTests.length + 1;
								result = THIS.methodСoncatenate(result, BD.sequencePage[16]);
								
								result.test.questions.forEach(function(item, index){
									for(var item2 of response.lastTests){
										if(item.id == item2.id){
											// console.log(item, '==', item2)
											result.test.questions[index] = item2;
										}
									}
								})
								
								console.log(result.test.questions)
							}else{
								result.pageID = testDepend(ID, 'next', ID);
								if(result.pageID == 7){
									THIS.sendGoal('city')
								}else if(result.pageID == 8){
									THIS.sendGoal('street')
								}else if(result.pageID == 9){
									THIS.sendGoal('housenum')
								}else if(result.pageID == 14){
									THIS.sendGoal('photo')
								}
								result = THIS.methodСoncatenate(result, BD.sequencePage[testDepend(ID, 'next', ID)]);
							}

						}

					}
				//SUCCES=FALSE==============================================================================
				}else{
					if(response.errorText){
						// alert(response.errorText)
						THIS.setAlertStatus(false, `<div style="text-align:center">${response.errorText}</div>`)
					}
					BD.sequencePage[ID].error = true;
					if(response.timeToNextShans){
						console.log(response) 
					}
					result.error = true;
				}



				THIS.setState(result);

			});

		}else if(data.nav == 'back' && this.state.pageID != 0){

			if (data.test && this.state.testID > 0) {
				result.testID = this.state.testID - 1;
			}else{
				result.pageID = testDepend(ID, 'back', ID);
				result = this.methodСoncatenate(result,  BD.sequencePage[testDepend(ID, 'back', ID)]);
			}
			
			result.helper = '';

			this.setState(result);

		}else if(data.nav == 'home'){

			result.pageID = 0;
			result = this.methodСoncatenate(result,  BD.sequencePage[0]);

			result.helper = '';

			this.setState(result);

		}else if(data.err === true){
			console.log('включить ошибку')
			BD.sequencePage[ID].error = true;
			result = this.methodСoncatenate(result,  BD.sequencePage[ID]);
			result.error = true;
			this.setState(result);
		}else if(data.err === false){
			console.log('выкючить ошибку')
			BD.sequencePage[ID].error = false;
			result = this.methodСoncatenate(result,  BD.sequencePage[ID]);
			result.error = false;
			this.setState(result);
		}else{

			if(data.data) checkRegion(data.data, activeFieldName)

			result.error = false;
			BD.sequencePage[ID].error = false;
			this.setState(result);
		}



	},
	setOpperativeKey: function(key){
		
		// if(this.state.opperativeKey.onChange && this.state.opperativeKey.keyCode == '8'){

		// }
		if(JSON.stringify(key) != '{}'){
			console.log('key', key);
			this.setState({opperativeKey: key})
		}
		
	},
	focusKeyboard: function(){
		if(this._input){
			this._input.focus();
		}
	},
	actionSelectCustomVariant: function(){
    // console.log('sdfsdf')
    this.setState({showKeyboardFromTest: !this.state.showKeyboardFromTest})
	},
	setAlertStatus: function(some, text, notClean){
		// console.log('setAlertStatus', some, text, notClean)

		var newStatus = typeof some == 'boolean' ? some : true,
				notCleanAfterTyping = typeof notClean == 'boolean' ? notClean : true

		var newAlertStatuses = this.state.alertStatuses,
				wasFound = false;

		for(var item of newAlertStatuses){
			if(item && item.id == this.state.pageID){
				wasFound = true;
				item.status = newStatus;
				// item.text = text;
				if(text && typeof text == "string"){
					item.text = text;
				}
				if(typeof notClean == 'boolean'){
					item.notClean = notClean;
				}
				if(newStatus && item.notClean){
					item.text = '';
				}
			}
		}
		if(!wasFound){
			var pushObj = {
				id: this.state.pageID,
				status: newStatus,
				notClean: notCleanAfterTyping
			}
			if(text && typeof text == "string"){
				pushObj.text = text;
			}
			newAlertStatuses.push(pushObj)
		}
		this.setState({alertStatuses: newAlertStatuses});
	},

	render: function(){
		if(this.state.list === true && typeof this.state.formEnd == 'undefined'){
			if(this.state.pageID === 0){
				return (
					<div className="AppForm">
						<List
							width="4"
							height="4"
							mobile={this.state.mobile}
							// data={BD.specialtiesGroups}
							data={this.state.specialties}
							actionSaveField={this.handleSaveField}
						/>
					</div>
				);
			}else{
				return(
					<div>404</div>
				);
			}
		}else if (typeof this.state.formEnd == 'undefined'){
			setInterval(()=>{
				if(!this._input){
					document.body.style.overflow = "auto";
				}else{
					document.body.style.overflow = "hidden";
				}
			}, 1000)
			var alertStatus = false,
					alertText = BD.sequencePage[this.state.pageID].alert;

			for(var item of this.state.alertStatuses){
				if(item && item.id == this.state.pageID){
					alertStatus = item.status;
					if(item.text){
						alertText = item.text;
					}
					
				}
			}
			
			return(
				<div className="AppForm">
					{this.state.showKeyboardFromTest || this.state.typeKeyboard == 'numbers' || this.state.typeKeyboard == 'letters' || this.state.typeKeyboard == 'letters2' || this.state.typeKeyboard == 'lettersLat' || this.state.typeKeyboard == 'numbersAndLetters' || this.state.typeKeyboard == 'numbersMoney' || this.state.typeKeyboard == 'NumbersAndLettersLat' ? (
						<input
							style={{marginTop: -135, fontSize: 1, height: 1, opacity: 0, position: 'absolute'}}
							type={this.state.typeKeyboard == 'numbers' || this.state.typeKeyboard == 'numbersMoney' ? "tel" : "text"}
							pattern={this.state.typeKeyboard == 'numbers' || this.state.typeKeyboard == 'numbersMoney' ? "\d*" : null}
							className="input"
							ref={(c) => this._input = c}
							onKeyDown={function(e){
								if(e.key != 'Unidentified'){
									var keyEvent = {
										key: e.key,
										keyCode: e.keyCode,
										random: Math.random(),
										onKeyDown: true
									}
									e.preventDefault();
									this.setOpperativeKey(keyEvent);
								}
								
							}.bind(this)}
							onChange={function(e){
								if(!this.state.opperativeKey || this.state.opperativeKey.onKeyDown || this.state.opperativeKey.key == 'Unidentified' || this.state.opperativeKey.onChange || JSON.stringify(this.state.opperativeKey) == '{}'){
									var value = e.target.value[1] || 'Unidentified';
									var newOperativeKey = {
										key: value,
										keyCode: '999999',
										random: Math.random(),
										onChange: true
									};
									if(e.target.value == ''){
										newOperativeKey.keyCode = '8'
										newOperativeKey.key = 'A'
										
									}
									e.preventDefault();
									setTimeout(()=>{
										this._input.setSelectionRange(1, 1);
									}, 10)
									this.setOpperativeKey(newOperativeKey);
								}
								
							}.bind(this)}
							onBlur={function(){
								console.log('onBlur')
								var THIS = this;
								if(document.querySelector('.keyboardButton input')){
									document.querySelector('.keyboardButton input').disabled = false;
								}
								setTimeout(function(){
									if(THIS._input && document.querySelector('jdiv textarea') && !document.querySelector('jdiv textarea').matches(":focus")){
										THIS._input.focus()
									}else if(THIS._input && document.querySelector('jdiv textarea')){
										document.querySelector('jdiv textarea').addEventListener("blur", function(){
											THIS._input.focus()
										});
									}
								}, 100)
								document.body.style.overflow = "auto";
								setInterval(function(){
									if(THIS._input && (!document.querySelector('jdiv textarea') || ( document.querySelector('jdiv textarea') && !document.querySelector('jdiv textarea').matches(":focus")))){
										THIS._input.focus()
									}
								}, 1000)
							}.bind(this)}
							onFocus={function(){
								console.log('onFocus')
								document.body.style.overflow = "hidden";
								this._input.setSelectionRange(1, 1);
							}.bind(this)}
							value="0"
						/>
					) : null}
					<KeyboardWrapper
						unicPhoto={this.state.unicPhoto}
						refId2={this.props.params.id2}
						pageID={this.state.pageID}
						mobile={this.state.mobile}
						typeWrapper={this.state.typeWrapper}
						typeKeyboard={this.state.typeKeyboard}
						namePage={this.state.namePage}
						nameSize={this.state.nameSize}
						defaultText={this.state.defaultText}
						startText={this.state.startText}
						text={this.state[BD.sequencePage[this.state.pageID].name]}
						actionSaveField={this.handleSaveField}
						autoNext={this.state.autoNext}
						regexp={this.state.regexp}
						emptyNext={this.state.emptyNext}
						error={this.state.error}
						test={typeof this.state.test != 'undefined' &&  this.state.test !== false ? this.state.test.questions[this.state.testID] : null}
						helper={this.state.helper}
						setOpperativeKey={this.setOpperativeKey}
						opperativeKey={this.state.opperativeKey}
						focusKeyboard={this.focusKeyboard}
						nameField={BD.sequencePage[this.state.pageID].name}
						alert={alertText}
						alertStatus={alertStatus}
						setAlertStatus={this.setAlertStatus}
						yandexTry={this.state.yandexTry}
						loading={this.state.loading}
						reloadPage={this.reloadPage}
						actionSelectCustomVariant={this.actionSelectCustomVariant}
						showKeyboardFromTest={this.state.showKeyboardFromTest}
						advertisingSites={this.state.advertisingSites}
					/>
					
				</div>
			);
			
		}else{

			console.log('this.state.specialty', this.state.specialty)
			
			if (this.state.specialty == "Почтальон" ||  this.state.specialty == "Расклейщик" ||  this.state.specialty == "Промоутер"){

			return(
				
				<div className="AppForm">
					<div className="resultForm">
						<div className="resultFormWrapper">
							<div style={{height: 256, display: 'flex', flexDirection: 'column', justifyContent: 'center'}}>
								<h1>Отлично!</h1>
								{this.state.resultTest ? (
									<div>
										<h2>Ожидайте, с вами свяжится менеджер.</h2>
										<h2>Начните работать уже сейчас!</h2>
										{this.state.mobile ? (
											<div>
												<a href={this.state.linkApp} target="_blank"><button>Скачать приложение</button></a>
												<a href={this.state.linkChat} target="_blank"><button>Связаться с нами</button></a>
											</div>
										) : (
											<h2 style={{width: 500, margin: '15px auto 0'}}>На ваш номер телефона отправленно смс с ссылкой на приложение и инструкцией.</h2>
										)}
									</div>
								) : null}
								{!this.state.resultTest && this.state.resultTestChance ? (
									<h2>Ожидайте, с вами свяжится менеджер.</h2>
								) : null}
								{!this.state.resultTest && !this.state.resultTestChance  ? (
									// <h2 style={{width: this.state.mobile ? 'auto' : 500, margin: '15px auto 0'}}>Начните работать уже сейчас!</h2>
									
									<div>
										<h2>Начните работать уже сейчас!</h2>
										
										{this.state.mobile ? (
											<div>
												<a href="https://ibot.pro/getPostman" target="_blank"><button>Приложение для работы</button></a>
												
												<a href="https://youtu.be/jNOEHvgK8co" target="_blank"><button>Видео о работе</button></a> 

												<a href="https://ibot.pro/telegramPostman" target="_blank"><button>Перейти в чат</button></a> 

											</div>
										) 
										: (
										
										<h2 style={{width: this.state.mobile ? 'auto' : 500, margin: '15px auto 0'}}>Свяжитесь с нами https://t.me/master_rabota</h2>
										
										)
										
										}
									</div>

								) : null}
								{!this.state.mobile ? (<button onClick={this.reloadPage} >Начать сначала</button>) : null }
							</div>
						</div>
					</div>
				</div>
			)}
			else {

				return(
				
					<div className="AppForm">
						<div className="resultForm">
							<div className="resultFormWrapper">
								<div style={{height: 256, display: 'flex', flexDirection: 'column', justifyContent: 'center'}}>
									<h1>Отлично!</h1>
									{this.state.resultTest ? (
										<div>
											<h2>Ожидайте, с вами свяжится менеджер.</h2>
											<h2>Начните работать уже сейчас!</h2>
											{this.state.mobile ? (
												<div>
													<a href={this.state.linkApp} target="_blank"><button>Скачать приложение</button></a>
													<a href={this.state.linkChat} target="_blank"><button>Связаться с нами</button></a>
												</div>
											) : (
												<h2 style={{width: 500, margin: '15px auto 0'}}>На ваш номер телефона отправленно смс с ссылкой на приложение и инструкцией.</h2>
											)}
										</div>
									) : null}
									{!this.state.resultTest && this.state.resultTestChance ? (
										<h2>Ожидайте, с вами свяжится менеджер.</h2>
									) : null}
									{!this.state.resultTest && !this.state.resultTestChance  ? (
										// <h2 style={{width: this.state.mobile ? 'auto' : 500, margin: '15px auto 0'}}>Начните работать уже сейчас!</h2>
										
										<div>
											<h2>Начните работать уже сейчас!</h2>
											
											{this.state.mobile ? (
												<div>
													<a href="https://ibot.pro/getService" target="_blank"><button>Скачать приложение</button></a>
													
													<a href="https://youtu.be/leyKF3dS8lU" target="_blank"><button>Видео презентация</button></a> 
	
													<a href="https://t.me/master_rabota" target="_blank"><button>Перейти в чат</button></a> 
	
												</div>
											) 
											: (
											
											<h2 style={{width: this.state.mobile ? 'auto' : 500, margin: '15px auto 0'}}>Свяжитесь с нами https://t.me/master_rabota</h2>
											
											)
											
											}
										</div>
	
									) : null}
									{!this.state.mobile ? (<button onClick={this.reloadPage} >Начать сначала</button>) : null }
								</div>
							</div>
						</div>
					</div>
				)

			}
		}

	},
	componentDidUpdate: function(){
		if(this.state.formEnd){
			this.handleFormEnd();
		}
	}
});

export default MainPage;



/** WEBPACK FOOTER **
 ** ./assets/apps/AppForm/index.jsx
 **/